import React, { FC, ReactElement } from 'react'
import styled, { css } from 'styled-components'

interface Props {
  angle?: number
  className?: string
  onClick?: (event) => void
  svg: ReactElement
}

const ArrowRoot = styled.div<{ angle: number }>(({ angle }) => css`
  -webkit-transform: rotate(${angle}deg);
  -moz-transform: rotate(${angle}deg);
  -ms-transform: rotate(${angle}deg);
  -o-transform: rotate(${angle}deg);
  transform: rotate(${angle}deg);
`)

const Arrow: FC<Props> = ({ angle = 0, className, onClick = undefined, svg }) => (
  <ArrowRoot angle={angle} className={className} onClick={onClick}>
    {svg}
  </ArrowRoot>
)

export default Arrow
